import React from "react"
import markdown from "../../scripts/markdown"
import Image from "../elements/Image"
import { filterHTML } from "../../scripts/xss"

class TourStep extends React.Component {
  youtubeID = url => {
    return url.split("v=")[1]
  }
  render() {
    const { item, index, currentStep } = this.props
    const itemImageUrl =
      item.files.length > 0 ? item.files[0].images.medium.url : ""
    // const itemYoutubeURL = item.youtube_url.length > 0 ? item.youtube_url : ""
    // TODO: uncomment once youtube_url attribute is implimented in backend.
    // This is not implimented currently due to manual_schema.json being harcoded, preventing
    // updates to the schema.
    const itemYoutubeURL = item.creator === null ? "" : item.creator
    const youtubeUrl = this.youtubeID(itemYoutubeURL)
    const showVideo = itemYoutubeURL.length > 0
    const showImage = !showVideo && itemImageUrl.length > 0
    if (currentStep !== index) {
      return null
    }
    return (
      <div className="modal-content">
        {showImage ? <Image src={itemImageUrl} /> : null}
        {showVideo ? (
          <div className="modal-video">
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${youtubeUrl}`}
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        ) : null}
        <section data-article-style="grid">
          <h1>{item.title}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: markdown.render(filterHTML(item.description))
            }}
          />
        </section>
      </div>
    )
  }
}

export default TourStep



// WEBPACK FOOTER //
// ./webapp/components/modules/TourStep.js